function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.793 7.4999H2.5C2.36739 7.4999 2.24021 7.55258 2.14645 7.64635C2.05268 7.74011 2 7.86729 2 7.9999C2 8.13251 2.05268 8.25968 2.14645 8.35345C2.24021 8.44722 2.36739 8.4999 2.5 8.4999H11.793L8.146 12.1459C8.05211 12.2398 7.99937 12.3671 7.99937 12.4999C7.99937 12.6327 8.05211 12.76 8.146 12.8539C8.23989 12.9478 8.36722 13.0005 8.5 13.0005C8.63278 13.0005 8.76011 12.9478 8.854 12.8539L13.354 8.3539C13.4006 8.30745 13.4375 8.25228 13.4627 8.19153C13.4879 8.13079 13.5009 8.06567 13.5009 7.9999C13.5009 7.93413 13.4879 7.86901 13.4627 7.80827C13.4375 7.74752 13.4006 7.69234 13.354 7.6459L8.854 3.1459C8.76011 3.05201 8.63278 2.99927 8.5 2.99927C8.36722 2.99927 8.23989 3.05201 8.146 3.1459C8.05211 3.23979 7.99937 3.36712 7.99937 3.4999C7.99937 3.63267 8.05211 3.76001 8.146 3.8539L11.793 7.4999Z",
  fill: "#0A6B5A"
});

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.4f3b6f9cf2833646ca54ad23aebd7828.svg";
export { ForwardRef as ReactComponent };